import { HttpClient } from 'api/http-client';
import { AccountFeature } from 'hooks/use-account-feature';

export interface AccountFeatureResponse {
  [key: string]: boolean;
}
class AccountFeatureHttpClient extends HttpClient {
  public enableFeature(
    feature: AccountFeature,
  ): Promise<AccountFeatureResponse> {
    return this.put(`features/${feature}`);
  }

  public disableFeature(
    feature: AccountFeature,
  ): Promise<AccountFeatureResponse> {
    return this.delete(`features/${feature}`);
  }
}

export const AccountFeatureAPI = new AccountFeatureHttpClient();
